import { create } from "zustand";
import { ResType, Widget } from "../interfaces/ResponseTypes";
import { ContinueDraft } from "../api/continueDraft";
import { Payload } from "../interfaces/Payload";
import useAppStore from "./AppStore";
import { ContactUsType } from "../interfaces/ContactUsType";
import { FinalizeButtonDataType } from "../interfaces/FinalizeButtonType";
import { myListingRedirect } from "../helpers/commonFunctions";
import { ActionDimensions } from "../membership/logging/dimensions/ActionDimensions";

type State = {
  components: Widget[];
  contactBox: ContactUsType | null;
  loading: boolean;
  finalizeButton: FinalizeButtonDataType | null;
  prevData: any;
  closeButtonText?: string;
  closeButtonTitle?: string;
  forceRenderContactUs?: boolean;
};

type Actions = {
  setComponents: (data: ResType) => void;
  _clearComponents: () => void;
  continueDraft: (body: Payload, keep?: boolean) => Promise<void>;
};

const useComponentsStore = create<State & Actions>((set, get, state) => ({
  components: [],
  finalizeButton: null,
  contactBox: null,
  loading: true,
  prevData: null,
  closeButtonText: null,
  closeButtonTitle: null,
  forceRenderContactUs: false,
  _clearComponents: () =>
    set({
      components: [],
      contactBox: null,
      finalizeButton: null,
      loading: true,
    }),
  setComponents: (data: ResType) => {
    get()._clearComponents();
    const finalizedWidgets = data.widgets;
    if (data.finalizeButton) {
      finalizedWidgets.push({
        type: "finalizeButton",
        data: data.finalizeButton ? { ...data.finalizeButton } : null,
      });
    }
    set({
      components: finalizedWidgets,
      loading: false,
      contactBox: data?.box,
      finalizeButton: data?.finalizeButton,
      prevData:
        data?.skipConfirmation?.type == "back" && data?.skipConfirmation?.undo
          ? data?.skipConfirmation?.undo
          : null,
      closeButtonText: data?.closeButton?.message || null,
      closeButtonTitle: data?.closeButton?.title || null,
      forceRenderContactUs: data?.forceRenderContactUs ?? false
    });
  },
  continueDraft: async (body: Payload, keepData = false) => {
    const res = await ContinueDraft(body, useAppStore.getState().token);
    if (res.status < 300 && res.status >= 200) {
      const outcome = res.data.outcome;
      const completeFlow = res.data.completeFlow;
      if (completeFlow) return myListingRedirect();
      if (outcome === "checkout") {
        window.location.href = res.data.payload.redirect + `&SessionFunnelSource=${ActionDimensions.getInstance().sessionFunnelSource}`;
        return;
      }
      if (keepData) return;
      get().setComponents(res.data);
    }
  },
}));

export default useComponentsStore;
